import React from 'react';
import {Table} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";
import FormattedDate from "../../components/formatters/formattedDate";
import Decimal from "../../components/formatters/decimal";
import Currency from "../../components/formatters/currency";

export default class HHTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            frequencyText: "Yearly"
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.meterType || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.meterReference || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.companySiteName && `${this.props.data.companySiteName}, `}{this.props.data.propertyName && `${this.props.data.propertyName}, `}{this.props.data.siteAddress && `${this.props.data.siteAddress}, `}{this.props.data.town && `${this.props.data.town}, `}{this.props.data.postCode && `${this.props.data.postCode}`}</Table.Cell>
    <Table.Cell>{this.props.data.siteID || <NoData/>}</Table.Cell>
                <Table.Cell><FormattedDate value={this.props.data.date}/></Table.Cell>
                <Table.Cell>{this.props.data.dayOfWeek || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.dataType || <NoData/>}</Table.Cell>
                <Table.Cell><Decimal value={this.props.data.totalUsage}/></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.md}/></Table.Cell>
                <Table.Cell><Currency value={this.props.data.estimatedCost}/></Table.Cell>
            </Table.Row>
        );
    }

    componentDidMount = () => {
        this.fetchData();
    }

    fetchData = () => {

    }

    componentDidUpdate = () => {

    }
}